// Webpack Imports
import * as bootstrap from "bootstrap";
import $ from "jquery/dist/jquery";
import Swiper from "swiper/bundle";
import BigPicture from "bigpicture";
import Decimal from 'decimal.js';
//require('./js/libs/ion.rangeSlider-2.3.1/js/ion.rangeSlider')
import LoadingOverlay from "gasparesganga-jquery-loading-overlay";
import ionRangeSlider from "ion-rangeslider";

window.BigPicture = BigPicture;
window.jQuery = $;
window.$ = $;
import "slick-carousel";
import {float} from "../../../../wp-includes/js/codemirror/csslint";

(function () {
    "use strict";
    (function ($, window, document, undefined) {
        var pluginName = "accordion",
            defaults = {
                transitionSpeed: 300,
                transitionEasing: "ease",
                controlElement: "[data-control]",
                contentElement: "[data-content]",
                groupElement: "[data-accordion-group]",
                singleOpen: true,
            };

        function Accordion(element, options) {
            this.element = element;
            this.options = $.extend({}, defaults, options);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        Accordion.prototype.init = function () {
            var self = this,
                opts = self.options;

            var $accordion = $(self.element),
                $controls = $accordion.find("> " + opts.controlElement),
                $content = $accordion.find("> " + opts.contentElement);

            var accordionParentsQty = $accordion.parents("[data-accordion]").length,
                accordionHasParent = accordionParentsQty > 0;

            var closedCSS = {"max-height": 0, overflow: "hidden"};

            var CSStransitions = supportsTransitions();

            function debounce(func, threshold, execAsap) {
                var timeout;

                return function debounced() {
                    var obj = this,
                        args = arguments;

                    function delayed() {
                        if (!execAsap) func.apply(obj, args);
                        timeout = null;
                    }

                    if (timeout) clearTimeout(timeout);
                    else if (execAsap) func.apply(obj, args);

                    timeout = setTimeout(delayed, threshold || 100);
                };
            }

            function supportsTransitions() {
                var b = document.body || document.documentElement,
                    s = b.style,
                    p = "transition";

                if (typeof s[p] == "string") {
                    return true;
                }

                var v = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];

                p = "Transition";

                for (var i = 0; i < v.length; i++) {
                    if (typeof s[v[i] + p] == "string") {
                        return true;
                    }
                }

                return false;
            }

            function requestAnimFrame(cb) {
                if (window.requestAnimationFrame) {
                    requestAnimationFrame(cb);
                } else if (window.webkitRequestAnimationFrame) {
                    webkitRequestAnimationFrame(cb);
                } else if (window.mozRequestAnimationFrame) {
                    mozRequestAnimationFrame(cb);
                } else {
                    setTimeout(cb, 1000 / 60);
                }
            }

            function toggleTransition($el, remove) {
                if (!remove) {
                    $content.css({
                        "-webkit-transition":
                            "max-height " +
                            opts.transitionSpeed +
                            "ms " +
                            opts.transitionEasing,
                        transition:
                            "max-height " +
                            opts.transitionSpeed +
                            "ms " +
                            opts.transitionEasing,
                    });
                } else {
                    $content.css({
                        "-webkit-transition": "",
                        transition: "",
                    });
                }
            }

            function calculateHeight($el) {
                var height = 0;

                $el.children().each(function () {
                    height = height + $(this).outerHeight(true);
                });

                $el.data("oHeight", height);
            }

            function updateParentHeight(
                $parentAccordion,
                $currentAccordion,
                qty,
                operation
            ) {
                var $content = $parentAccordion
                        .filter(".open")
                        .find("> [data-content]"),
                    $childs = $content.find("[data-accordion].open > [data-content]"),
                    $matched;

                if (!opts.singleOpen) {
                    $childs = $childs.not(
                        $currentAccordion
                            .siblings("[data-accordion].open")
                            .find("> [data-content]")
                    );
                }

                $matched = $content.add($childs);

                if ($parentAccordion.hasClass("open")) {
                    $matched.each(function () {
                        var currentHeight = $(this).data("oHeight");

                        switch (operation) {
                            case "+":
                                $(this).data("oHeight", currentHeight + qty);
                                break;
                            case "-":
                                $(this).data("oHeight", currentHeight - qty);
                                break;
                            default:
                                throw "updateParentHeight method needs an operation";
                        }

                        $(this).css("max-height", $(this).data("oHeight"));
                    });
                }
            }

            function refreshHeight($accordion) {
                if ($accordion.hasClass("open")) {
                    var $content = $accordion.find("> [data-content]"),
                        $childs = $content.find("[data-accordion].open > [data-content]"),
                        $matched = $content.add($childs);

                    calculateHeight($matched);

                    $matched.css("max-height", $matched.data("oHeight"));
                }
            }

            function closeAccordion($accordion, $content) {
                $accordion.trigger("accordion.close");

                if (CSStransitions) {
                    if (accordionHasParent) {
                        var $parentAccordions = $accordion.parents("[data-accordion]");

                        updateParentHeight(
                            $parentAccordions,
                            $accordion,
                            $content.data("oHeight"),
                            "-"
                        );
                    }

                    $content.css(closedCSS);

                    $accordion.removeClass("open");
                } else {
                    $content.css("max-height", $content.data("oHeight"));

                    $content.animate(closedCSS, opts.transitionSpeed);

                    $accordion.removeClass("open");
                }
            }

            function openAccordion($accordion, $content) {
                $accordion.trigger("accordion.open");
                if (CSStransitions) {
                    toggleTransition($content);

                    if (accordionHasParent) {
                        var $parentAccordions = $accordion.parents("[data-accordion]");

                        updateParentHeight(
                            $parentAccordions,
                            $accordion,
                            $content.data("oHeight"),
                            "+"
                        );
                    }

                    requestAnimFrame(function () {
                        $content.css("max-height", $content.data("oHeight"));
                    });

                    $accordion.addClass("open");
                } else {
                    $content.animate(
                        {
                            "max-height": $content.data("oHeight"),
                        },
                        opts.transitionSpeed,
                        function () {
                            $content.css({"max-height": "none"});
                        }
                    );

                    $accordion.addClass("open");
                }
            }

            function closeSiblingAccordions($accordion) {
                var $accordionGroup = $accordion.closest(opts.groupElement);

                var $siblings = $accordion.siblings("[data-accordion]").filter(".open"),
                    $siblingsChildren = $siblings
                        .find("[data-accordion]")
                        .filter(".open");

                var $otherAccordions = $siblings.add($siblingsChildren);

                $otherAccordions.each(function () {
                    var $accordion = $(this),
                        $content = $accordion.find(opts.contentElement);

                    closeAccordion($accordion, $content);
                });

                $otherAccordions.removeClass("open");
            }

            function toggleAccordion() {
                var isAccordionGroup = opts.singleOpen
                    ? $accordion.parents(opts.groupElement).length > 0
                    : false;

                calculateHeight($content);

                if (isAccordionGroup) {
                    closeSiblingAccordions($accordion);
                }

                if ($accordion.hasClass("open")) {
                    closeAccordion($accordion, $content);
                } else {
                    openAccordion($accordion, $content);
                }
            }

            function addEventListeners() {
                $controls.on("click", toggleAccordion);

                $controls.on("accordion.toggle", function () {
                    if (opts.singleOpen && $controls.length > 1) {
                        return false;
                    }

                    toggleAccordion();
                });

                $controls.on("accordion.refresh", function () {
                    refreshHeight($accordion);
                });

                $(window).on(
                    "resize",
                    debounce(function () {
                        refreshHeight($accordion);
                    })
                );
            }

            function setup() {
                $content.each(function () {
                    var $curr = $(this);

                    if ($curr.css("max-height") != 0) {
                        if (!$curr.closest("[data-accordion]").hasClass("open")) {
                            $curr.css({"max-height": 0, overflow: "hidden"});
                        } else {
                            toggleTransition($curr);
                            calculateHeight($curr);

                            $curr.css("max-height", $curr.data("oHeight"));
                        }
                    }
                });

                if (!$accordion.attr("data-accordion")) {
                    $accordion.attr("data-accordion", "");
                    $accordion.find(opts.controlElement).attr("data-control", "");
                    $accordion.find(opts.contentElement).attr("data-content", "");
                }
            }

            setup();
            addEventListeners();
        };

        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, "plugin_" + pluginName)) {
                    $.data(this, "plugin_" + pluginName, new Accordion(this, options));
                }
            });
        };
        $(".search-btn").on("click", function (e) {
            e.preventDefault();
            $(this).parent().addClass("open");
        });
        $(".chat-button").on("click", function (e) {
            e.preventDefault();
            $(this).toggleClass("active");
        });

        $(".close-form").on("click", function (e) {
            e.preventDefault();
            $(this).parents(".search-group").removeClass("open");
        });
    })(jQuery, window, document);

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
        el.addEventListener("submit", function (e) {
            var search = el.querySelector("input");
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: "focus",
        });
    });

    window.app = {el: {}, fn: {}};
    app.el["window"] = $(window);
    app.el["document"] = $(document);
    app.el["html-body"] = $("html,body");
    app.el["body"] = $("body");
    app.el["back-to-top"] = $(".back-to-top");

    $(".bottom-nav li.dropdown").on("mouseenter", function () {
        let $header = $("header#header");
        $header.addClass("over");
        $header.on("mouseleave", function () {
            $(this).removeClass("over");
        });
    });

    //Smooth scroll to ID
    $(".scroll-to").on("click", function (event) {
        var target = $(this).attr("href");
        if ($(target).length) {
            event.preventDefault();
            app.el["html-body"].animate(
                {
                    scrollTop: $(target).offset().top,
                },
                750
            );
        }
    });

    // Back to top
    app.el["back-to-top"].click(function (event) {
        event.preventDefault();
        app.el["html-body"].animate(
            {
                scrollTop: 0,
            },
            750
        );
    });

    function fadeScrollTop() {
        if (app.el["window"].scrollTop() > 500) {
            app.el["back-to-top"].fadeIn();
        } else {
            app.el["back-to-top"].fadeOut();
        }
    }

    // Window scroll events
    app.el["window"].on("scroll", function () {
        fadeScrollTop();
    });

    $(".mobile-menu-toggle").on("click", function (event) {
        event.preventDefault();
        $(".menu-mobile").toggleClass("open");
    });

    $(".banner-carousel").slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
    $(".vns-carousel").slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".accordion").accordion({
        transitionSpeed: 400,
    });

    // Calculator
    let $calculatorForm = $(".calculator form");
    let $mediumSelector = $("#mediumSelector");
    let $radioValue = $("input[name='calcValue']");
    let $kvWert = $(".kvWert");
    let $durchFluss = $(".durchFluss");
    let $druckVerlust = $(".druckVerlust");
    let $temp = $(".temp");
    let $rho1 = $(".rho1");

    let $mediumValue = undefined;
    let $calcValue;
    let $resKv, $resDurch, $resDruck;
    $mediumSelector.on("change", function () {
        $mediumValue = this.value;
        if (
            this.value === "druckluft" ||
            this.value === "co2" ||
            this.value === "wasserstoff" ||
            this.value === "stickstoff" ||
            this.value === "helium"
        ) {
            $temp.addClass("open");
            $rho1.addClass("open");
        } else {
            $temp.removeClass("open");
            $rho1.removeClass("open");
        }
        enableRadioValueSelectors();
    });

    $radioValue.on("change", function () {
        $calcValue = this.value;
        let $allInputsContainer = $(".kvWert, .durchFluss, .druckVerlust");
        $allInputsContainer.each(function () {
            $(this).find("input").removeAttr("required");
        });

        showInputFields($calcValue);
        calcInputReset();
    });

    function showInputFields(radioValue) {
        switch (radioValue) {
            case "kvWert":
                slideAndReset("kvWert");
                break;
            case "durchFluss":
                slideAndReset("durchFluss");
                break;
            case "druckVerlust":
                slideAndReset("druckVerlust");
                break;
            default:
                console.log("Error");
        }
        $calculatorForm
            .find(".calculator__form-group.open input:visible")
            .attr("required", true);
    }

    function calculateLiquidKv(qn, p1, deltap) {
        let q = new Decimal(qn);
        let rho1 = new Decimal(p1);
        let deltarho = new Decimal(deltap);
        let p = rho1.add(1);
        let kv = q * Decimal.sqrt((p / deltarho));

        return kv;
    }

    function calculateKv(qn, p1, rho, temp, gamma, deltap) {
        let q = new Decimal(qn);
        let rho1 = new Decimal(p1);
        let rhoN = new Decimal(rho);
        let t1 = new Decimal(temp);
        let g = new Decimal(gamma);
        let deltarho = new Decimal(deltap);
        let p = rho1.add(1);
        let x = Decimal.div(deltarho, p);
        let y = 1 - (x / g.times(1.4));

        let kv = (q / (519 * p * y)) * Decimal.sqrt(rhoN * (t1.add(273.15)) / x);

        return kv;
    }

    function calculateQn(kv, p1, rho, temp, gamma, deltap) {
        let kv1 = new Decimal(kv);
        let rho1 = new Decimal(p1);
        let rhoN = new Decimal(rho);
        let t1 = new Decimal(temp);
        let g = new Decimal(gamma);
        let deltarho = new Decimal(deltap);
        let p = rho1.add(1);
        let x = Decimal.div(deltarho, p);
        let y = 1 - (x / g.times(1.4));

        let q = kv1 * 519 * p * y * Decimal.sqrt(x / (rhoN * (t1.add(273.15))));
        return q;
    }

    function calculateDeltaP(kv, qn, rho, temp, p1) {
        let kv1 = new Decimal(kv);
        let q = new Decimal(qn);
        let rhoN = new Decimal(rho);
        let t1 = new Decimal(temp);
        let rho1 = new Decimal(p1);
        let p = rho1.add(1);
        let x = Decimal.pow(q, 2).times(rhoN).times(t1.add(273.15));
        let y = Decimal.pow(kv1, 2).times(519).times(519).times(p);

        let deltarho = Decimal.div(x, y);

        return deltarho;
    }

    function calculateValues(e, mediumVal, radioVal) {
        e.preventDefault();
        let rho = 1000;
        let rhoN = 1.3;
        let kvWertInput = $("#kvWertInput").val();
        let kvResult = 0;
        let durchflussInput = $("#durchflussInput").val();
        let durchflussResult = 0;
        let druckVerlustInput = $("#druckVerlustInput").val();
        let druckVerlustResult = 0;
        let temperatur = $("#temperatur").val();
        let x = 0;
        let p1 = $("#p1").val();
        let z = 0;
        let gamma = 0;
        let xT = 0;
        let y = 0;
        let criticalFlow = false;
        switch (mediumVal) {
            case "wasser":
                switch (radioVal) {
                    case "kvWert":
                        kvResult = durchflussInput * Math.sqrt((p1 + 1) / druckVerlustInput);
                        break;
                    case "durchFluss":
                        durchflussResult =
                            kvWertInput * Math.sqrt((druckVerlustInput * rho) / (rho + 1));
                        break;
                    case "druckVerlust":

                        druckVerlustResult = Math.pow((durchflussInput / kvWertInput), 2) * rho / 1000;
                        break;
                }
                break;
            case "kuehlschmierstoff":
                switch (radioVal) {
                    case "kvWert":
                        rho = 900;
                        kvResult = durchflussInput * Math.sqrt((p1 + 1) / druckVerlustInput);
                        break;
                    case "durchFluss":
                        rho = 900;
                        durchflussResult =
                            kvWertInput * Math.sqrt((druckVerlustInput * rho) / (rho + 1));
                        break;
                    case "druckVerlust":
                        rho = 900;
                        druckVerlustResult = Math.pow((durchflussInput / kvWertInput), 2) * rho / 1000;
                        break;
                }
                break;
            case "hydraulikoel":
                switch (radioVal) {
                    case "kvWert":
                        rho = 830;
                        kvResult = durchflussInput * Math.sqrt((p1 + 1) / druckVerlustInput);
                        break;
                    case "durchFluss":
                        rho = 830;
                        durchflussResult =
                            kvWertInput * Math.sqrt((druckVerlustInput * rho) / (rho + 1));
                        break;
                    case "druckVerlust":
                        rho = 830;
                        druckVerlustResult = Math.pow((durchflussInput / kvWertInput), 2) * rho / 1000;
                        break;
                }
                break;
            case "oel":
                switch (radioVal) {
                    case "kvWert":
                        rho = 850;
                        kvResult = durchflussInput * Math.sqrt((p1 + 1) / druckVerlustInput);
                        break;
                    case "durchFluss":
                        rho = 850;
                        durchflussResult =
                            kvWertInput * Math.sqrt((druckVerlustInput * rho) / (rho + 1));
                        break;
                    case "druckVerlust":
                        rho = 850;
                        druckVerlustResult = Math.pow((durchflussInput / kvWertInput), 2) * rho / 1000;
                        break;
                }
                break;
            case "druckluft":
                rhoN = 1.3;
                if (
                    typeof druckVerlustInput === "undefined" ||
                    druckVerlustInput === null
                ) {
                    druckVerlustResult = 1;
                }

                z = 1;
                gamma = 1.4;
                // Calculate $x for critical flow
                x = druckVerlustInput / p1;
                xT = 0.6;
                y = 1 - (x / (1.4 * gamma));
                switch (radioVal) {
                    case "kvWert":
                        kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        break;
                    case "durchFluss":
                        durchflussResult = calculateQn(kvWertInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        break;
                    case "druckVerlust":
                        druckVerlustResult = calculateDeltaP(kvWertInput, durchflussInput, rhoN, temperatur, p1);
                        break;
                }
                break;
            case "wasserstoff":
                rhoN = 0.09;
                if (
                    typeof druckVerlustInput === "undefined" ||
                    druckVerlustInput === null
                ) {
                    druckVerlustResult = 1;
                }
                z = 1;
                gamma = 1.4;
                // Calculate $x for critical flow
                x = druckVerlustInput / (p1 + 1);
                xT = 0.6;
                y = 1 - x / (1.4 * gamma);

                switch (radioVal) {
                    case "kvWert":
                        if (x < 0.5) {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        } else {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        }
                        break;
                    case "durchFluss":
                        durchflussResult = calculateQn(kvWertInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        break;
                    case "druckVerlust":
                        druckVerlustResult = calculateDeltaP(kvWertInput, durchflussInput, rhoN, temperatur, p1);
                        break;
                }
                break;
            case "helium":
                rhoN = 0.18;
                if (
                    typeof druckVerlustInput === "undefined" ||
                    druckVerlustInput === null
                ) {
                    druckVerlustResult = 1;
                }
                z = 1;
                gamma = 1.67;
                // Calculate $x for critical flow
                x = druckVerlustInput / (p1 + 1);
                xT = 0.6;
                y = 1 - x / (1.67 * gamma);

                switch (radioVal) {
                    case "kvWert":
                        if (x < 0.5) {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        } else {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        }
                        break;
                    case "durchFluss":
                        durchflussResult = calculateQn(kvWertInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        break;
                    case "druckVerlust":
                        druckVerlustResult = calculateDeltaP(kvWertInput, durchflussInput, rhoN, temperatur, p1);
                        break;
                }
                break;
            case "stickstoff":
                rhoN = 1.25;
                if (
                    typeof druckVerlustInput === "undefined" ||
                    druckVerlustInput === null
                ) {
                    druckVerlustResult = 1;
                }
                z = 1;
                gamma = 1.4;
                // Calculate $x for critical flow
                x = druckVerlustInput / (p1 + 1);
                xT = 0.6;
                y = 1 - x / (1.4 * gamma);

                switch (radioVal) {
                    case "kvWert":
                        if (x < 0.5) {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        } else {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        }
                        break;
                    case "durchFluss":
                        durchflussResult = calculateQn(kvWertInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        break;
                    case "druckVerlust":
                        druckVerlustResult = calculateDeltaP(kvWertInput, durchflussInput, rhoN, temperatur, p1);
                        break;
                }
                break;
            case "co2":
                rhoN = 2;
                if (
                    typeof druckVerlustInput === "undefined" ||
                    druckVerlustInput === null
                ) {
                    druckVerlustResult = 1;
                }
                z = 1;
                gamma = 1.3;
                // Calculate $x for critical flow
                x = druckVerlustInput / (p1 + 1);
                xT = 0.6;
                y = 1 - x / (1.3 * gamma);

                switch (radioVal) {
                    case "kvWert":
                        if (x < 0.5) {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        } else {
                            kvResult = calculateKv(durchflussInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        }
                        break;
                    case "durchFluss":
                        durchflussResult = calculateQn(kvWertInput, p1, rhoN, temperatur, gamma, druckVerlustInput);
                        break;
                    case "druckVerlust":
                        druckVerlustResult = calculateDeltaP(kvWertInput, durchflussInput, rhoN, temperatur, p1);
                        break;
                }
                break;
        }

        showResults(
            radioVal,
            criticalFlow,
            kvResult,
            durchflussResult,
            druckVerlustResult
        );
    }

    function roundResults(num) {
        return num.toFixed(5);
    }

    function showResults(
        radioVal,
        criticalFlow,
        kvResult,
        durchflussResult,
        druckVerlustResult
    ) {
        // console.log(
        //     radioVal,
        //     criticalFlow,
        //     kvResult,
        //     durchflussResult,
        //     druckVerlustResult
        // );
        let $resultsContainer = $("#result-js");
        $resultsContainer.find("li").addClass("d-none");
        if (criticalFlow === true) {
            $resultsContainer
                .find(".critical-result")
                .find("span>span")
                .text("Kann nicht berechnet werden!");
            $resultsContainer.find(".critical-result").removeClass("d-none");
        } else {
            switch (radioVal) {
                case "kvWert":
                    $resultsContainer
                        .find(".kv-result")
                        .find("span>span")
                        .text(roundResults(kvResult));
                    $resultsContainer.find(".kv-result").removeClass("d-none");
                    break;
                case "durchFluss":
                    $resultsContainer
                        .find(".durchfluss-result")
                        .find("span>span")
                        .text(roundResults(durchflussResult));
                    $resultsContainer.find(".durchfluss-result").removeClass("d-none");
                    break;
                case "druckVerlust":
                    $resultsContainer
                        .find(".druckverlust-result")
                        .find("span>span")
                        .text(roundResults(druckVerlustResult));
                    $resultsContainer.find(".druckverlust-result").removeClass("d-none");
                    break;
            }
        }
    }

    function validateP1durchflussInput() {
        let mediumVal = $("#mediumSelector").val();
        let radioVal = $('input[name="calcValue"]:checked').val();
        let p1InputVal = $("#p1").val();
        let druckverlustInputVal = $("#druckVerlustInput").val();
        let durchflussInputVal = $("#durchflussInput").val();
        let kvWertInputVal = $("#kvWertInput").val();
        let validation = true;
        let validationMessage = "";

        if (
            (mediumVal === "druckluft" ||
                mediumVal === "co2" ||
                mediumVal === "wasserstoff" ||
                mediumVal === "stickstoff" ||
                mediumVal === "helium") &&
            (radioVal === "durchFluss" || radioVal === "kvWert")
        ) {
            if (p1InputVal < druckverlustInputVal) {
                validation = false;
                validationMessage =
                    "Der Eingabewert für den Druckverlust darf nicht größer sein als der Eingabewert für p1!";
            }
            if (druckverlustInputVal / p1InputVal > 0.5) {
                validation = false;
                validationMessage =
                    "Kritische Strömung! Bitte überprüfen Sie Ihre Eingaben!";
            }
        }

        /*console.log(
            durchflussInputVal,
            kvWertInputVal,
            druckverlustInputVal,
            p1InputVal
        );*/

        switch (radioVal) {
            case "kvWert":
                if (parseFloat(durchflussInputVal) === 0) {
                    validation = false;
                    validationMessage =
                        "Der Eingabewert für den Durchfluss darf nicht 0 sein!";
                }
                if (parseFloat(druckverlustInputVal) === 0) {
                    validation = false;
                    validationMessage =
                        "Der Eingabewert für den Druckverlust darf nicht 0 sein!";
                }
                if (parseFloat(p1InputVal) === 0) {
                    validation = false;
                    validationMessage = "Der Eingabewert für p1 darf nicht 0 sein!";
                }
                break;
            case "durchFluss":
                if (parseFloat(kvWertInputVal) === 0) {
                    validation = false;
                    validationMessage =
                        "Der Eingabewert für den Kv-Wert darf nicht 0 sein!";
                }
                if (parseFloat(druckverlustInputVal) === 0) {
                    validation = false;
                    validationMessage =
                        "Der Eingabewert für den Druckverlust darf nicht 0 sein!";
                }
                if (parseFloat(p1InputVal) === 0) {
                    validation = false;
                    validationMessage = "Der Eingabewert für p1 darf nicht 0 sein!";
                }
                break;
            case "druckVerlust":
                if (parseFloat(kvWertInputVal) === 0) {
                    validation = false;
                    validationMessage =
                        "Der Eingabewert für den Kv-Wert darf nicht 0 sein!";
                }
                if (parseFloat(durchflussInputVal) === 0) {
                    validation = false;
                    validationMessage =
                        "Der Eingabewert für den Durchfluss darf nicht 0 sein!";
                }
                if (parseFloat(p1InputVal) === 0) {
                    validation = false;
                    validationMessage = "Der Eingabewert für p1 darf nicht 0 sein!";
                }
                break;
        }
        //console.log(validation, validationMessage);
        let $resultsContainer = $("#result-js");
        $resultsContainer.find("li").addClass("d-none");
        $resultsContainer.find("li span>span").text("");
        $resultsContainer.find(".critical-result").text(validationMessage);
        $resultsContainer.find(".critical-result").removeClass("d-none");
        return [validation, validationMessage];
    }

    $(document).on("change", "#p1", function (e) {
        validateP1durchflussInput();
    });

    $calculatorForm.on("submit", function (e) {
        e.preventDefault();
        let mediumVal = $("#mediumSelector").val();
        let radioVal = $calcValue;

        let validation = validateP1durchflussInput();
        if (validation[0] === false) {
        } else {
            calculateValues(e, mediumVal, radioVal);
        }
    });

    $calculatorForm.on("reset", function (e) {
        e.preventDefault();

        let $resultsContainer = $("#result-js");
        let $allInputsContainer = $(
            ".kvWert, .durchFluss, .druckVerlust, .temp, .rho1"
        );
        $allInputsContainer.each(function () {
            $(this).find("input").removeAttr("required");
        });
        $resultsContainer.find("li").addClass("d-none");
        $resultsContainer.find("li span>span").text("");
        calcReset();
    });

    function slideAndReset(radioValue) {
        let $allInputsContainer = $(".kvWert, .durchFluss, .druckVerlust");
        $allInputsContainer.each(function () {
            $(this).removeClass("open");
            $(this).find("input").val("");
        });
        $.wait = function (ms) {
            let defer = $.Deferred();
            setTimeout(function () {
                defer.resolve();
            }, ms);
            return defer;
        };

        switch (radioValue) {
            case "kvWert":
                $druckVerlust.addClass("open");
                $durchFluss.addClass("open");
                break;
            case "durchFluss":
                $druckVerlust.addClass("open");
                $kvWert.addClass("open");
                break;
            case "druckVerlust":
                $durchFluss.addClass("open");
                $kvWert.addClass("open");
                break;
            default:
                console.log("Sorry, we are out of " + radioValue + ".");
        }

        return true;
    }

    function calcReset() {
        let $allInputsContainer = $(
            ".kvWert, .durchFluss, .druckVerlust, .temp, .rho1"
        );
        $allInputsContainer.each(function () {
            $(this).removeClass("open");
            $(this).find("input").val("");
        });
        $mediumSelector.prop("selectedIndex", 0);
        $radioValue.prop("checked", false);
    }

    function calcInputReset() {
        let $allInputsContainer = $(
            ".kvWert, .durchFluss, .druckVerlust, .temp, .rho1"
        );
        $allInputsContainer.each(function () {
            $(this).find("input").val("");
        });
    }

    function enableRadioValueSelectors() {
        $radioValue.each(function () {
            $(this).attr("disabled", false);
        });
    }

    $(".videoLightbox .vid").on("click", function () {
        BigPicture({
            el: this,
            vidSrc: $(this).attr("vidSrc"),
        });
    });

    /*
        Filter
         */
    let $productFilterHolder = $("#product-filter-holder");
    let $productResults = $("#results-target");
    let animateTime = 500;
    /*
        Start and Stop Overlay for every AJAX Call
         */
    $(document).ajaxStart(function () {
        $.LoadingOverlay("show");
    });
    $(document).ajaxStop(function () {
        $.LoadingOverlay("hide");
    });

    $(document).on("change", "input[data-option-group]", function (e) {
        let $selectedTarget = $(this);
        let $label = $selectedTarget.next().html();
        let $parent = $selectedTarget.parents(".form-check-check");
        // $parent.before('<p class="selected-label">' + $label + "<span></span></p>");
        // $parent.slideUp();

        getProductResults();
    });

    $(document).on("click", ".selected-label span", function (e) {
        let $selectedLabel = $(this).parent();
        let $input = $selectedLabel.next().find("input[data-option-group]:checked");
        $input.prop("checked", false);
        $selectedLabel.next().slideDown();
        $selectedLabel.hide().stop().remove();
        getProductResults();
    });

    $(document).on("click", ".product-filter__btn a", function (e) {
        e.preventDefault();
        getProductResults();
    });

    $('.product-filter input[name="product_categories"]').on(
        "change",
        function (e) {
            e.preventDefault();
            let $selectedCategory = $(this).val();
            $(".loadmore-wrapper").removeClass("hidden");

            getProductResults();
            currentPageProducts = 1;
            getFilterForCategory($selectedCategory);
        }
    );

    function getFilterForCategory(selectedCategory) {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
                action: "filtersForProductCategories",
                product_category: selectedCategory,
            },
            success: function (res) {
                $productFilterHolder.html(res);
                productFilterCalc();
                autoHeightAnimate($productFilterHolder, animateTime);
            },
        });
    }

    function getProductResults(currentpage = 1) {
        let druckbereichLow = null,
            druckbereichHigh = null,
            nennweiteLow = null,
            nennweiteHigh = null,
            kvLow = null,
            kvHigh = null;
        let selectedCategory = $(
            '.product-filter input[name="product_categories"]:checked'
        ).val();
        let ausfuehrungSelected = $(
            "input:checkbox[data-option-group=ausfuehrung]:checked"
        )
            .map(function () {
                return $(this).val();
            })
            .get();
        let wirkungsweiseSelected = $(
            "input:checkbox[data-option-group=wirkungsweise]:checked"
        )
            .map(function () {
                return $(this).val();
            })
            .get();
        let betaetigungsartSelected = $(
            "input:checkbox[data-option-group=betaetigungsart]:checked"
        )
            .map(function () {
                return $(this).val();
            })
            .get();
        let gehauseSelected = $("input:checkbox[data-option-group=gehause]:checked")
            .map(function () {
                return $(this).val();
            })
            .get();

        if ($("input#druckbereich:checked")) {
            let $druckInputMin = $("[druckbereichrange-input-min-js]");
            let $druckInputMax = $("[druckbereichrange-input-max-js]");
            if (!$druckInputMin.val()) {
                $(".js-range-slider-druckbereich").data("min");
            } else {
                druckbereichLow = $druckInputMin.val();
            }
            if (!$druckInputMax.val()) {
                $(".js-range-slider-druckbereich").data("max");
            } else {
                druckbereichHigh = $druckInputMax.val();
            }
        }

        if ($("input#nennweite:checked")) {
            let $nwInputMin = $("[nennweiterange-input-min-js]");
            let $nwInputMax = $("[nennweiterange-input-max-js]");
            if (!$nwInputMin.val()) {
                $(".js-range-slider-nennweite").data("min");
            } else {
                nennweiteLow = $nwInputMin.val();
            }
            if (!$nwInputMax.val()) {
                $(".js-range-slider-nennweite").data("max");
            } else {
                nennweiteHigh = $nwInputMax.val();
            }
        }

        if ($("input#kv:checked")) {
            let $kvlInputMax = $("[kvrange-input-max-js]");
            let $kvlInputMin = $("[kvrange-input-min-js]");
            if (!$kvlInputMin.val()) {
                $(".js-range-slider-kv").data("min");
            } else {
                kvLow = $kvlInputMin.val();
            }
            if (!$kvlInputMax.val()) {
                $(".js-range-slider-kv").data("max");
            } else {
                kvHigh = $kvlInputMax.val();
            }
        }

        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "json",
            data: {
                action: "filtersForProducts",
                product_category: selectedCategory,
                gehaeuse: gehauseSelected,
                betaetigung: betaetigungsartSelected,
                ausfuehrung: ausfuehrungSelected,
                wirkungsweise: wirkungsweiseSelected,
                nennweite_low: nennweiteLow,
                nennweite_high: nennweiteHigh,
                druckbereich_low: druckbereichLow,
                druckbereich_high: druckbereichHigh,
                kv_wert_low: kvLow,
                kv_wert_high: kvHigh,
                paged: currentpage,
            },
            success: function (res) {
                if (currentpage >= res.max) {
                    $(".loadmore-wrapper").addClass("hidden");
                } else {
                    $(".loadmore-wrapper").removeClass("hidden");
                }
                if (res.paged > 1) {
                    $productResults.append(res.html);
                } else {
                    $productResults.html(res.html);
                }
                $("#product-count span").html(res.count);
                // Scroll to results
                // $("html, body").animate({ scrollTop: $productResults.offset().top }, 800);
                filterResultsForRangeProducts();
                let elCount = $("#results-target > div:not(.d-none)").length;
                // console.log($("#results-target > div"));
                // console.log(elCount);

                $("#product-count span").html(elCount);
            },
        });
    }

    function filterResultsForRangeProducts() {
        let $druckCheckbox = $("input#druckbereich:checked");
        let $kvCheckbox = $("input#kv:checked");
        let $nennweiteCheckbox = $("input#nennweite:checked");
        let $druckInputMin = $("[druckbereichrange-input-min-js]");
        let druckInputMinVal = parseFloat($druckInputMin.val()).toFixed(2);
        let $druckInputMax = $("[druckbereichrange-input-max-js]");
        let druckInputMaxVal = parseFloat($druckInputMax.val()).toFixed(2);
        let $kvlInputMax = $("[kvrange-input-max-js]");
        let kvInputMaxVal = parseFloat($kvlInputMax.val()).toFixed(2);
        let $kvlInputMin = $("[kvrange-input-min-js]");
        let kvInputMinVal = parseFloat($kvlInputMin.val()).toFixed(2);
        let $nwInputMin = $("[nennweiterange-input-min-js]");
        let nwInputMinVal = parseFloat($nwInputMin.val()).toFixed(2);
        let $nwInputMax = $("[nennweiterange-input-max-js]");
        let nwInputMaxVal = parseFloat($nwInputMax.val()).toFixed(2);
        let passDruck = false;
        let passNennweite = false;
        let passKv = false;
        let $resultsTarget = $("#results-target > div");
        $resultsTarget.each(function () {
            if ($druckCheckbox.length > 0) {
                // Filter by druck range
                if (!isNaN(druckInputMinVal) || !isNaN(druckInputMaxVal)) {
                    let druckHigh = new Decimal($(this).data("druckhigh"));
                    let druckLow = new Decimal($(this).data("drucklow"));
                    let dInputMax = new Decimal(druckInputMaxVal);
                    let dInputMin = new Decimal(druckInputMinVal);
                    //console.log(dInputMax.lte(druckHigh));
                    //console.log(druckLow.lte(dInputMin));
                    if (!isNaN(druckHigh) && !isNaN(druckLow)) {
                        if (dInputMax.lte(druckHigh) && druckLow.lte(dInputMin)) {
                            passDruck = true;
                            $(this).addClass("druckpass");
                        } else {
                            $(this).removeClass("druckpass");
                        }
                    } else {
                        passDruck = true;
                        $(this).addClass("druckpass");
                    }
                }
            } else {
                passDruck = true;
                $(this).addClass("druckpass");
            }

            if ($kvCheckbox.length > 0) {
                // Filter by kv range
                if (!isNaN(kvInputMinVal) || !isNaN(kvInputMaxVal)) {
                    let kvHigh = new Decimal($(this).data("kvhigh"));
                    let kvLow = new Decimal($(this).data("kvlow"));
                    let kvInputMax = new Decimal(kvInputMaxVal);
                    let kvInputMin = new Decimal(kvInputMinVal);
                    if (!isNaN(kvHigh) && !isNaN(kvLow)) {
                        if (
                            kvInputMax.lte(kvHigh) && kvLow.lte(kvInputMin)
                        ) {
                            passKv = true;
                            $(this).addClass("kvpass");
                        } else {
                            $(this).removeClass("kvpass");
                        }
                    } else {
                        $(this).addClass("kvpass");
                        passKv = true;
                    }
                }
            } else {
                $(this).addClass("kvpass");
                passKv = true;
            }
            if ($nennweiteCheckbox.length > 0) {
                // Filter by nennweite range
                if (!isNaN(nwInputMinVal) || !isNaN(nwInputMaxVal)) {
                    let nennweiteHigh = new Decimal($(this).data("nennweitehigh"));
                    let nennweiteLow = new Decimal($(this).data("nennweitelow"));
                    let nwInputMax = new Decimal(nwInputMaxVal);
                    let nwInputMin = new Decimal(nwInputMinVal);
                    // console.log(nennweiteHigh, nennweiteLow);
                    // console.log(nwInputMax.lte(nennweiteHigh), nennweiteLow.lte(nwInputMin));
                    if (!isNaN(nennweiteHigh) && !isNaN(nennweiteLow)) {

                        if (
                            nwInputMax.lte(nennweiteHigh) && nennweiteLow.lte(nwInputMin)

                        ) {
                            passNennweite = true;
                            $(this).addClass("nennweitepass");
                        } else {
                            $(this).removeClass("nennweitepass");
                        }
                    } else {
                        $(this).addClass("nennweitepass");
                        passNennweite = true;
                    }
                }
            } else {
                $(this).addClass("nennweitepass");
                passNennweite = true;
            }

            $(this).addClass("d-none");

        });

        $resultsTarget.filter('.druckpass.kvpass.nennweitepass').removeClass('d-none');

    }

    /*
        Productcategory Load more
         */
    let currentPageProducts = 1;
    $(".page-produkte #load-more").on("click", function () {
        currentPageProducts++;
        getProductResults(currentPageProducts);
    });

    /* Function to animate height: auto */
    function autoHeightAnimate(element, time) {
        let curHeight = element.height(), // Get Default Height
            autoHeight = element.css("height", "auto").height(); // Get Auto Height
        element.height(curHeight); // Reset to Default Height
        element.stop().animate({height: autoHeight}, time); // Animate to Auto Height
    }

    /*
        Productfilter Rangeslider
         */

    function productFilterCalc() {
        let druckbereichrange = $(".js-range-slider-druckbereich"),
            nennweiterange = $(".js-range-slider-nennweite"),
            kvrange = $(".js-range-slider-kv"),
            druckbereichrangeInputMin = $("[druckbereichrange-input-min-js]"),
            druckbereichrangeInputMax = $("[druckbereichrange-input-max-js]"),
            nennweiteInputMin = $("[nennweiterange-input-min-js]"),
            nennweiteInputMax = $("[nennweiterange-input-max-js]"),
            kvInputMin = $("[kvrange-input-min-js]"),
            kvInputMax = $("[kvrange-input-max-js]");

        function checkedCB(el, instanceEl, inputArr) {
            if ($(el).is(":checked")) {
                instanceEl.update({block: false});
                $(inputArr).removeAttr("disabled");
            } else {
                $(el).parent(".form-check").find("[data-option-group]").val("");
                instanceEl.update({block: true});
                $(inputArr).attr("disabled", true);
            }
        }

        function inputFromCB(inputEl, instanceEl) {
            var val = $(inputEl).prop("value");

            if (val < instanceEl.options.min) {
                val = instanceEl.options.min;
            } else if (val > instanceEl.options.to) {
                val = instanceEl.options.to;
            }

            instanceEl.update({from: val});
            $(inputEl).prop("value", val);
        }

        function inputToCB(inputEl, instanceEl) {
            var val = $(inputEl).prop("value");

            if (val < instanceEl.options.from) {
                val = instanceEl.options.from;
            } else if (val > instanceEl.options.max) {
                val = instanceEl.options.max;
            }

            instanceEl.update({to: val});
            $(inputEl).prop("value", val);
        }

        druckbereichrange.ionRangeSlider({
            type: "double",
            skin: "sharp",
            grid: true,
            block: true,
            onFinish: function onFinish(ev) {
                druckbereichrangeInputMin.prop("value", ev.from);
                druckbereichrangeInputMax.prop("value", ev.to);
                getProductResults();
            },
        });

        nennweiterange.ionRangeSlider({
            type: "double",
            skin: "sharp",
            grid: true,
            block: true,
            onFinish: function onFinish(ev) {
                nennweiteInputMin.prop("value", ev.from);
                nennweiteInputMax.prop("value", ev.to);
                getProductResults();
            },
        });

        kvrange.ionRangeSlider({
            type: "double",
            skin: "sharp",
            grid: true,
            block: true,
            step: 0.1,
            onFinish: function onFinish(ev) {
                kvInputMin.prop("value", ev.from);
                kvInputMax.prop("value", ev.to);
                getProductResults();
            },
        });

        let druckbereichrange_instance = druckbereichrange.data("ionRangeSlider"),
            nennweiterange_instance = nennweiterange.data("ionRangeSlider"),
            kvrange_instance = kvrange.data("ionRangeSlider");

        $("[druckbereichrange-checked-js]").on("change", function (ev) {
            checkedCB(
                ev.currentTarget,
                druckbereichrange_instance,
                "[druckbereichrange-input-min-js], [druckbereichrange-input-max-js]"
            );
            filterResultsForRangeProducts();

        });

        $("[nennweiterange-checked-js]").on("change", function (ev) {
            checkedCB(
                ev.currentTarget,
                nennweiterange_instance,
                "[nennweiterange-input-min-js], [nennweiterange-input-max-js]"
            );
            filterResultsForRangeProducts();
        });

        $("[kvrange-checked-js]").on("change", function (ev) {
            checkedCB(
                ev.currentTarget,
                kvrange_instance,
                "[kvrange-input-min-js], [kvrange-input-max-js]"
            );
            filterResultsForRangeProducts();
        });

        druckbereichrangeInputMin.on("change", function (ev) {
            if (druckbereichrangeInputMax.val() === "") {
                druckbereichrangeInputMax.val(0);
            }
            return inputFromCB(druckbereichrangeInputMin, druckbereichrange_instance);
        });
        druckbereichrangeInputMax.on("change", function (ev) {
            if (druckbereichrangeInputMin.val() === "") {
                druckbereichrangeInputMin.val(0);
            }
            return inputToCB(druckbereichrangeInputMax, druckbereichrange_instance);
        });

        nennweiteInputMin.on("change", function (ev) {
            if (nennweiteInputMax.val() === "") {
                nennweiteInputMax.val(0);
            }
            return inputFromCB(nennweiteInputMin, nennweiterange_instance);
        });
        nennweiteInputMax.on("change", function (ev) {
            if (nennweiteInputMin.val() === "") {
                nennweiteInputMin.val(0);
            }
            return inputToCB(nennweiteInputMax, nennweiterange_instance);
        });

        kvInputMin.on("change", function (ev) {
            if (kvInputMax.val() === "") {
                kvInputMax.val(0);
            }
            return inputFromCB(kvInputMin, kvrange_instance);
        });
        kvInputMax.on("change", function (ev) {
            if (kvInputMin.val() === "") {
                kvInputMin.val(0);
            }
            return inputToCB(kvInputMax, kvrange_instance);
        });
    }

    /*
        Productcategory Load more
         */
    let currentPage = 1;
    $(".tax-product_categories #load-more").on("click", function () {
        let selectedCategory = $(this).data("category");
        currentPage++;
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "json",
            data: {
                action: "load_more_products",
                paged: currentPage,
                product_category: selectedCategory,
            },
            success: function (res) {
                if (currentPage >= res.max) {
                    $(".loadmore-wrapper").addClass("hidden");
                } else {
                    $(".loadmore-wrapper").removeClass("hidden");
                }
                $("#results-target").append(res.html);
            },
        });
    });

    /*
     * Slider
     */
    var swiper = new Swiper(".productSwiper", {
        spaceBetween: 10,
        slidesPerView: 1,
        loop: true,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".productSwiperThumbs", {
        spaceBetween: 10,
        slidesPerView: 3,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });
})();
